import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthenticationActions } from './shared/authentication/action-types';
import { MatDialog } from '@angular/material/dialog';
import { Observable, filter, map, of, tap, timer } from 'rxjs';
import { isUserLoggedIn, userProfile } from './shared/user/user.selectors';
import { isAuthenticated } from './shared/authentication/authentication.selectors';
import { Configurations } from './shared/configurations/models/configurations.model';
import { APP_CONFIG } from './shared/configurations/configurations.factory';
import { AppRoute } from './app-routing.module';
import { UserRole } from './core/enums/user/user-role.enum';
import { UserProfile } from './core/models/user/user-profile.model';
import { environment } from 'src/environments/environment';
import { selectQueryParam, selectQueryParams } from './router.selectors';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class AppComponent {

  userRole = UserRole
  appRoute = AppRoute

  isUserLoggedIn$: Observable<boolean>
  isUserAuthenticated$: Observable<boolean>;
  user$: Observable<UserProfile>

  showLeftSidenav$: Observable<boolean>

  constructor(@Inject(APP_CONFIG) private config: Configurations, private appStore: Store, protected readonly matDialog: MatDialog) {
    this.isUserLoggedIn$ = appStore.select(isUserLoggedIn)
    this.isUserAuthenticated$ = appStore.pipe(isAuthenticated)
    this.user$ = appStore.pipe(userProfile)

    this.showLeftSidenav$ = appStore.select(selectQueryParams).pipe(
      filter(params => !!params),
      map(params => (JSON.parse(params[Object.keys(params).find(p => p.toLowerCase() == 'showleftsidenav') ?? ''] ?? 'false') as boolean))
    )
    // this.showLeftSidenav$ = of(true) // DebugMode
  }

  login() {

    this.appStore.dispatch(AuthenticationActions.signIn(
      {
        landingUrl: window.location.href
      }
    ))
  }

  logout() {
    this.appStore.dispatch(AuthenticationActions.signOut())
  }

}
